import React, { Fragment } from "react";
import { connect } from "react-redux";
import TimeslotsToday from "../components/logistics/TimeslotsToday";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import { getTimeslots } from "../actions/timeslotsAction";
import Spinner from "../components/layout/Spinner";
import axios from "axios";
import { API_ROOT } from "../components/utils/api-config";

let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/x-www-form-urlencoded",
  },
};
class TimeslotsContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getTimeslots(this.props.selectedDate);
  }

  handleDateChange = (date) => {
    this.props.setSelectedDate(moment(date).format("YYYY-MM-DD"));
    console.log(moment(date).format("YYYY-MM-DD"));
    this.props.getTimeslots(moment(date).format("YYYY-MM-DD"));
  };

  handleSwitchSubmit = (id, type, value) => {
    const formData = new FormData();
    formData.append(type, value);

    axios
      .patch(`${API_ROOT}/bookings/${id}`, formData, config)
      .then(() => this.props.getTimeslots(this.props.selectedDate))
      .catch((error) => console.log("api errors:", error));
  };

  handleDriversSubmit = (number_of_drivers) => {
    const formData = new FormData();

    formData.append(
      "number_of_drivers",
      `number_of_drivers=${number_of_drivers}`
    );
    formData.append("_method", "patch");

    axios
      .post(
        `${API_ROOT}/bookings/changenumdrivers?string_date=${this.props.selectedDate}`,
        formData,
        config
      )
      .then(() => this.props.getTimeslots(this.props.selectedDate))
      .catch((error) => console.log("api errors:", error));
  };
  render() {
    const { loading, timeslots } = this.props.timeslots;
    return (
      <Fragment>
        <Toolbar>
          <Tooltip title="Choose date">
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                margin="normal"
                variant="dialog"
                autoOk
                showTodayButton
                disableToolbar
                inputVariant="outlined"
                id="date-picker-dialog"
                // label="Choose Date"
                format="dddd, MMM DD"
                value={this.props.selectedDate}
                onChange={this.handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Tooltip>
        </Toolbar>
        {loading ? (
          <Spinner />
        ) : (
          <TimeslotsToday
            timeslots={timeslots.timeslots}
            fsas={timeslots.fsas}
            handleSwitchSubmit={this.handleSwitchSubmit}
            handleDriversSubmit={this.handleDriversSubmit}
          />
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ timeslots }) => ({
  timeslots: timeslots,
});
const mapDispatchToProps = (dispatch) => ({
  getTimeslots: (timeslots) => dispatch(getTimeslots(timeslots)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TimeslotsContainer);
